import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Public pages - no Supabase dependencies
import Auth from "@/pages/Auth";
import NotFound from "@/pages/NotFound";

// Lazy load everything that needs Supabase
const ResetPassword = lazy(() => import("@/pages/ResetPassword"));
const ProtectedApp = lazy(() => import("@/components/ProtectedApp"));

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          {/* Public routes - no auth provider, no Supabase */}
          <Route path="/auth" element={<Auth />} />
          <Route path="/reset-password" element={
            <Suspense fallback={<div className="flex items-center justify-center min-h-screen">Loading...</div>}>
              <ResetPassword />
            </Suspense>
          } />
          <Route path="/not-found" element={<NotFound />} />

          {/* Protected routes - lazy loaded with Supabase */}
          <Route path="/*" element={
            <Suspense fallback={<div className="flex items-center justify-center min-h-screen">Loading...</div>}>
              <ProtectedApp />
            </Suspense>
          } />
        </Routes>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
